import React, { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import * as BiIcons from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';

function ViewTechnicalExpert() {
    // const { id } = useParams()
    const history = useHistory();
    const queryClient = useQueryClient();
    const handleRoute = (id) =>{ 
        // history.push("/technicalexpert/"+id);
        window.location.href="/admin/technicalexpert/"+id
      }
    const { data: TechnicalExpertData, isLoading } = useQuery(
        'TechnicalExpertList',
        () => Fetcher('get', '/api/technicalexpert/get/listtechnicalexperts', {}))
    console.log("TechnicalExpertData", TechnicalExpertData)

    const mutationdelete = useMutation((params) => Fetcher('delete', '/api/technicalexpert/delete/technicalexperts', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Data Deleted')
                queryClient.invalidateQueries('TechnicalExpertList');
               
            } else {
                var msg = 'TechnicalExpertList - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    function deleteData(deleteId){
        var jsonRequest = {id: deleteId}
        mutationdelete.mutate(jsonRequest)
    }
    if (isLoading) return <div>Loading</div>
    return (
        <div>
            <div classname="content-wrapper">
                <section classname="content">
                    <div classname="container-fluid">
                        <div classname="row">
                            <div classname="col-sm-12">
                                <div classname="card-body" style={{ paddingleft: "50px" }}>
                                    <div classname="row">
                                        <div classname="col-sm-12 col-lg-offset-1">
                                        <div class="card-body table-responsive">
                                                            <table className="table table-bordered">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th scope="col" className="text-center" style={{ "width": "100px" }}>#</th>
                                                        <th scope="col" className="text-center" style={{ "width": "180px" }}>Name </th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}> Educational Qualification</th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>Total Work Experience</th>
                                                        <th scope="col" className="text-center" colspan="4">Nace Details</th>                                                       
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>Previous employer verification</th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>Action</th>                                                    
                                                    </tr>
                                                    <tr>
                                                    <th scope="col" className="text-center" style={{ "width": "100px" }}></th>
                                                        <th scope="col" className="text-center" style={{ "width": "180px" }}></th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}></th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}></th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>naceCode</th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>edu</th>                                                       
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>exp</th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>experties</th>
                                                        <th scope="col" className="text-center" style={{ "width": "180px" }}></th>
                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody >

                                                    {
                                                        TechnicalExpertData.data.response ?
                                                            TechnicalExpertData.data.response.map((item, index) => {
                                                                var tempData = item.naceDetails
                                                                console.log("tempdata", tempData)
                                                                console.log("tempdata", tempData.naceCode)
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="text-center">{index + 1}.</td>
                                                                        {/* <td className="text-center">{item.firstName}</td> */}
                                                                        <td className="text-center">{item.firstName}</td>
                                                                        <td className="text-center"> {item.educationQualification}</td>
                                                                        <td className="text-center">{item.totalWorkExperience}</td>
                                                                       
                                                                        <td colspan="4">
                                                                        {
                                                                            // tempData ?
                                                                            //     tempData.map((subitem, subindex) => {
                                                                            //         return (
                                                                            //         <tr key={subindex}>
                                                                            //             <td  className="text-center">{subitem.naceCode.label}</td>
                                                                            //             <td>{subitem.edu}</td>
                                                                            //             <td>{subitem.exp}</td>
                                                                            //             <td>{subitem.experties}</td>
                                                                            //         </tr>
                                                                            //         )})
                                                                            //     :
                                                                            //     <>No Nace Code data addded</>
                                                                             tempData ?
                                                                                tempData.map((subitem, subindex) => {
                                                                                    return (
                                                                            <table className="table table-bordered">
                                                                            <tbody key={subindex}>
                                                                                <tr>
                                                                                         <td style={{ "width": "120px" }}>{subitem.nabcbcodeName}</td>
                                                                                         <td style={{ "width": "120px" }}>{subitem.edu}</td>
                                                                                         <td style={{ "width": "120px" }}>{subitem.exp}</td>
                                                                                         <td style={{ "width": "120px" }}>{subitem.experties}</td>
                                                                                
                                                                                </tr>
                                                                                
                                                                            </tbody>
                                                                            </table>
                                                                           
                                                                              )})
                                                                                  :
                                                                                  <>No Nace Code data addded</>
                                                                        }
                                                                       
                                                                        </td>
                                                                        <td>{item.previousEmployerInfo}</td>

                                                                        <td className="text-center">
                                                                            <span style={{ "marginRight": "6%", "cursor": "pointer" }}onClick={()=>handleRoute(item._id)}  ><BiIcons.BiEdit /></span>
                                                                            <span style={{ "marginLeft": "6%", "cursor": "pointer" }} onClick={() => deleteData(item._id)}><AiIcons.AiOutlineDelete /></span>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <>No Data Added </>
                                                    }
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default ViewTechnicalExpert
